import { useCallback, useEffect, useState } from "react";
import UseInstall from "../hooks/UseInstall";
import "../styles/layouts/addtohome.scss";

const lastPromptedKey = "lastPrompted";
const weekLengthMs = 1000 * 60 * 60 * 24 * 7;

export default function AddToHome() {
  const [mayShow, setMayShow] = useState(false);
  const [{ mayInstall }, { prompt }] = UseInstall();

  const triggerMayShow = useCallback(() => {
    const lastPrompted = window.localStorage.getItem(lastPromptedKey);

    //if it's been more than a week, show prompt!
    if (!lastPrompted || Date.now() - lastPrompted > weekLengthMs) {
      setMayShow(true);
    }
  }, []);

  useEffect(() => {
    if (mayInstall) {
      triggerMayShow(true);
    }
  }, [mayInstall, triggerMayShow]);

  const addToHomeClick = useCallback(
    (yes) => {
      if (yes) {
        prompt();
      }

      setMayShow(false);
      window.localStorage.setItem(lastPromptedKey, Date.now());
    },
    [prompt]
  );

  return (
    <div
      className={`add-to-home-container ${
        mayShow ? `visible-fade` : `hidden-fade`
      }`}
    >
      <div className="add-to-home">
        <div className="message-container">
          Adicionar esta app ao seu ecrã inicial?
        </div>
        <div className="button-container">
          <button
            className="button-no"
            onClick={() => {
              addToHomeClick(true);
            }}
          >
            Adicionar
          </button>
          <button
            onClick={() => {
              addToHomeClick();
            }}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
